import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { tenantGuard } from './core/guards/tenant.guard';
import { featureGuard } from './core/feature-flags/feature.guard';

export const routes: Routes = [
    // ─── Public / Platform Routes ───
    {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
            import('./features/landing/landing-page.component').then(
                (m) => m.LandingPageComponent,
            ),
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./features/auth/login.component').then((m) => m.LoginComponent),
    },
    {
        path: 'register',
        loadComponent: () =>
            import('./features/auth/register.component').then((m) => m.RegisterComponent),
    },
    {
        path: 'onboarding',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./features/church-onboarding/church-onboarding.component').then(
                (m) => m.ChurchOnboardingComponent,
            ),
    },
    {
        path: 'churches',
        redirectTo: '',
    },

    // ─── Tenant-Scoped Admin Routes ───
    {
        path: ':slug/admin',
        canActivate: [authGuard, tenantGuard],
        loadComponent: () =>
            import('./features/admin/admin-layout.component').then(
                (m) => m.AdminLayoutComponent,
            ),
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('./features/admin/dashboard/dashboard.component').then(
                        (m) => m.DashboardComponent,
                    ),
            },
            {
                path: 'members',
                canActivate: [featureGuard('members')],
                loadComponent: () =>
                    import('./features/admin/members/members.component').then(
                        (m) => m.MembersComponent,
                    ),
            },
            {
                path: 'visitors',
                canActivate: [featureGuard('members')],
                loadComponent: () =>
                    import('./features/admin/visitors/visitors.component').then(
                        (m) => m.VisitorsComponent,
                    ),
            },
            {
                path: 'events',
                canActivate: [featureGuard('events')],
                loadComponent: () =>
                    import('./features/admin/events/events.component').then(
                        (m) => m.EventsComponent,
                    ),
            },
            {
                path: 'giving',
                children: [
                    {
                        path: '',
                        canActivate: [featureGuard('giving')],
                        loadComponent: () =>
                            import('./features/admin/giving/giving.component').then(
                                (m) => m.GivingComponent,
                            ),
                    },
                    {
                        path: 'setup',
                        loadComponent: () =>
                            import('./features/admin/giving/onboarding.component').then(
                                (m) => m.OnboardingComponent,
                            ),
                    },
                    {
                        path: 'kyc',
                        loadComponent: () =>
                            import('./features/admin/giving/kyc-onboarding.component').then(
                                (m) => m.KycOnboardingComponent,
                            ),
                    }
                ]
            },
            {
                path: 'accounting',
                loadComponent: () =>
                    import('./features/admin/accounting/accounting.component').then(
                        (m) => m.AccountingComponent,
                    ),
            },
            {
                path: 'campaigns',
                canActivate: [featureGuard('campaigns')],
                loadComponent: () =>
                    import('./features/admin/campaigns/campaigns.component').then(
                        (m) => m.CampaignsComponent,
                    ),
            },
            {
                path: 'sermons',
                canActivate: [featureGuard('sermons')],
                loadComponent: () =>
                    import('./features/admin/sermons/sermons.component').then(
                        (m) => m.SermonsComponent,
                    ),
            },
            {
                path: 'features',
                loadComponent: () =>
                    import('./features/admin/features/features.component').then(
                        (m) => m.FeaturesComponent,
                    ),
            },
            {
                path: 'settings',
                loadComponent: () =>
                    import('./features/admin/settings/settings.component').then(
                        (m) => m.SettingsComponent,
                    ),
            },
            {
                path: 'notifications',
                loadComponent: () =>
                    import('./features/admin/notifications/notification-list.component').then(
                        (m) => m.NotificationListComponent,
                    ),
            },
        ],
    },

    // ─── Public Church Site ───
    {
        path: 'c/:slug',
        loadChildren: () =>
            import('./features/church-portal/church-portal.routes').then(
                (m) => m.CHURCH_PORTAL_ROUTES,
            ),
    },

    // ─── Catch-all ───
    {
        path: '**',
        redirectTo: '',
    },
];
